<ng-container *transloco="let t">
  <div class="position-relative">
    <div class="x-button-wrapper">
      <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
    </div>
    <div class="d-flex justify-content-center pt-48-38">
      <h1>
        {{title}} </h1>
    </div>
    <div class="organiser-content-wrapper">
      @if (!requestSent) {
        <form [formGroup]="inputForm" class="w-100">
          <div class="row">
            <div class="col-12 col-lg-6">
              <div class="pt-20-10">
                <app-input formControlName="name" label="organiser.details.name"/>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="pt-20-10">
                <app-input formControlName="fullName" label="organiser.details.full.name"/>
              </div>
            </div>
          </div>
          <div class="pt-20-10">
            <app-input formControlName="website" label="organiser.details.web"/>
          </div>
          <div class="row">
            <div class="col-12 col-lg-6">
              <div class="pt-20-10">
                <app-input formControlName="email" label="organiser.details.email"/>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="pt-20-10">
                <app-tel-input [formControlName]="'phone'" [label]="t('organiser.details.phone')"
                               [numberPlaceholder]="t('organiser.details.phone')"/>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-lg-6">
              <div class="pt-20-10">
                <app-input formControlName="address" label="organiser.details.address"/>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="pt-20-10">
                <app-input formControlName="place" label="organiser.details.place"/>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-lg-6">
              <div class="pt-20-10">
                <app-input formControlName="zip" label="app.common.zip"/>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="pt-20-10">
                <app-select formControlName="country" [hasDefault]="true" [items]="countries" [valueKey]="'id'"
                            labelKey="id" labelKeyPrefix="app.common.country." label="app.common.country"/>
              </div>
            </div>
          </div>
        </form>
      } @else {
        <div class="d-flex justify-content-center">
        {{t("request.modal.sent")}}
      </div>
      }

      <div class="row pt-5">
        @if (requestSent) {
          <div class="col-6 offset-3">
            <app-button-alt [text]="t('app.common.close')" [borderColor]="'var(--teal-500)'"
                            [textColor]="'var(--grey-neutral-800)'" (onClickCallback)="onDismissClick()"
                            [buttonColor]="'transparent'" [isFullWidth]="true"/>
          </div>
        } @else {
          <div class="col-12 col-md-6 pb-3 pb-md-0">
            <app-button-alt [text]="t('app.common.cancel')" [borderColor]="'var(--teal-500)'"
                            [textColor]="'var(--grey-neutral-800)'" (onClickCallback)="onDismissClick()"
                            [buttonColor]="'transparent'" [isFullWidth]="true"/>
          </div>
          <div class="col-12 col-md-6">
            <app-button-alt [text]="t('app.common.confirm')"
                            (onClickCallback)="onConfirmClick()"
                            [isFullWidth]="true"/>
          </div>
        }
      </div>
    </div>
  </div>
</ng-container>
